// CUSTOM ICON COMPONENT
import duotone from 'icons/duotone';
import permissionsList from '../../constants/permissionsList';
import Car from '../../icons/Car';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SettingsIcon from '@mui/icons-material/Settings';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import AddIcon from '@mui/icons-material/Add';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ListIcon from '@mui/icons-material/List';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EditNoteIcon from '@mui/icons-material/EditNote';
// ==============================================================

// ==============================================================

export const navigations = [
  {
    type: 'label',
    label: 'Trip'
  },
  {
    name: 'Add new Trip',
    path: '/dashboard/add-trip',
    icon: AddIcon,
    access: permissionsList.Trip,
    write: true
  },
  {
    name: 'Trips',
    path: '/dashboard/trips',
    path1: '/dashboard/trips/list',
    icon: AirlineStopsIcon,
    access: permissionsList.Trip
  },
  {
    name: 'Quotes',
    path: '/dashboard/quotes',
    path1: '/dashboard/quotes/list',
    icon: EditNoteIcon,
    access: permissionsList.Trip
  },
  {
    type: 'label',
    label: 'Dashboard'
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: DashboardIcon,
    access: permissionsList.Dashboard
  },
  {
    name: 'Patients',
    path: '/dashboard/patients',
    icon: PersonAddAltIcon,
    access: permissionsList.Patient
  },
  {
    type: 'label',
    label: 'Admin'
  },
  {
    name: 'Roles and Permissions',
    path: '/admin/roles-and-permissions',
    icon: duotone.DiagramProject,
    access: permissionsList.RolesAndPermissions
  },
  {
    name: 'Users',
    icon: duotone.UserList,
    children: [
      {
        name: 'Users',
        path: '/admin/user-list/list',
        path1: '/admin/user-list/grid',
        access: permissionsList.Users
      },
      {
        name: 'Customers',
        path: '/admin/customers/list',
        path1: '/admin/customers/grid',
        access: permissionsList.Users
      },
      {
        name: 'Drivers',
        path: '/admin/drivers',
        access: permissionsList.Driver
      }
    ]
  },
  {
    name: 'Vehicles',
    icon: Car,
    children: [
      {
        name: 'Vehicles',
        path: '/admin/vehicles',
        access: permissionsList.Vehicle
      },
      {
        name: 'Groups',
        path: '/admin/groups',
        access: permissionsList.VehicleGroup
      },
      {
        name: 'Vehicle Types',
        path: '/admin/vehicle-types',
        access: permissionsList.VehicleType
      }
    ]
  },
  {
    name: 'Billing',
    icon: ReceiptLongIcon,
    children: [
      {
        name: 'Payors',
        path: '/admin/payors',
        access: permissionsList.Payor
      },
      {
        name: 'Invoices',
        path: '/admin/invoices',
        access: permissionsList.Invoice
      }
    ]
  },
  {
    name: 'Activity Logs',
    path: '/admin/activity-logs',
    access: permissionsList.CanViewActivityLog,
    icon: AnalyticsIcon
  },
  {
    name: 'Company List',
    path: '/admin/company-list',
    access: permissionsList.SystemAdmin,
    icon: ListIcon
  },
  {
    name: 'Settings',
    icon: SettingsIcon,
    children: [
      {
        name: 'Open API ',
        path: '/admin/open-api',
        access: permissionsList.OpenAPI
      },
      {
        name: 'Additional Services',
        path: '/admin/additional-services',
        access: permissionsList.BillingItem
      },
      {
        name: 'Trip Forms',
        path: '/admin/trip-forms',
        access: permissionsList.DynamicForm
      },
      {
        name: 'Private Pay Forms',
        path: '/admin/private-pay-forms',
        access: permissionsList.DynamicForm
      },
      {
        name: 'Patient Form',
        path: '/admin/dynamic-form/patient',
        access: permissionsList.DynamicForm,
        write: true
      },
      {
        name: 'Facilities',
        path: '/admin/facilities',
        access: permissionsList.Facility
      },
      {
        name: 'Providers',
        path: '/admin/providers',
        access: permissionsList.ProviderInvitation
      },
      {
        name: 'Connections',
        path: '/admin/connections',
        access: permissionsList.Connections
      },
      {
        name: 'Zones',
        path: '/admin/zones',
        access: permissionsList.Zones
      },
      {
        name: 'Level Of Service',
        path: '/dashboard/level-of-service',
        access: permissionsList.LevelOfService
      }
    ]
  }
];
